export { getCompanyHubPseudoAppRoute } from '../src/routes/company-hub/getCompanyHubPseudoAppRoute';
